module.exports = () => {
	return new Promise((resolve) => {
		return resolve(screen.colorDepth || 0);
	});
};
